<template>
  <div class="fa">
    <div class="form-box">
      <el-form
        :inline="true"
        size="mini"
        class="demo-form-inline form-father"
        label-position="top"
      >
        <el-form-item label="商户id">
          <el-input v-model="search_info.mch_id" placeholder="支持模糊查询"></el-input>
        </el-form-item>
        <el-form-item label="商户简称/注册名称">
          <el-input v-model="search_info.mch_name" placeholder="支持模糊查询"></el-input>
        </el-form-item>
        <el-form-item label="商户类型">
          <el-select
            style="width:300px"
            v-model="search_info.mch_type"
            placeholder="选择商户类型"
          >
            <el-option
              v-for="item in mch_type_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form
        size="mini"
        :inline="true"
        class="demo-form-inline form-father"
        label-position="top"
      >
        <el-form-item label="入驻时间">
          <el-date-picker
            style="width:300px"
            v-model="search_info.date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="gTime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商户联系人" placeholder="支持模糊查询">
          <el-input v-model="search_info.contact_man"></el-input>
        </el-form-item>
        <!-- <el-form-item >
           <el-input v-model="search_info.mobile_no"></el-input>
        </el-form-item> -->
        <el-form-item label="服务费率">
          <el-input
            v-model="search_info.service_charge"
            placeholder="通过费率查询必须精确如(0.25)"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        size="mini"
        :inline="true"
        class="demo-form-inline form-father"
        label-position="top"
      >
      </el-form>
    </div>
    <div
      style="width:100%;margin-bottom:2%;display: flex;justify-content: right;"
      class="form-father"
    >
      <!-- <el-input
        v-model="search_in"
        style="width:50%"
        placeholder="请输入内容"
        class="input-with-select"
      >
        <el-select
          style="width:150px"
          v-model="select_type"
          slot="prepend"
          placeholder="选择查询字段"
        >
          <el-option label="商户名称" value="1"></el-option>
          <el-option label="创建时间" value="2"></el-option>
          <el-option label="商户id" value="3"></el-option>
        </el-select>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchLike"
        ></el-button>
      </el-input> -->
      <div>
        <el-button type="success" @click="search">查询</el-button>
        <el-button type="warning" @click="resove">重置</el-button>
        <el-button type="primary" @click="exportExcel">导出</el-button>
      </div>
    </div>
    <div class="tab-box">
      <ve-table
        id="loading-container"
        :sort-option="sortOption"
        style="width:100%;"
        :scroll-width="1500"
        rowKeyFieldName="rowKey"
        :fixed-header="true"
        :columns="columns"
        :table-data="mch_list"
        :rowStyleOption="rowStyleOption"
        :cell-style-option="cellStyleOption"
        border-y
        border-x
        :max-height="350"
      />
    </div>
    <!-- 详情 -->
    <div class="detail-father" v-if="merfshow">
      <morf :feed="false" :mch_id="mch_id" :shopmanage="false" @colse-morf="merfshow = false"></morf>
      <!-- <div style="" class="close-morf" @click="">
        ✗
      </div> -->
    </div>
  </div>
</template>
<script>
import {getMerchantlist,queryMerchant} from '@/api/index'
import morf from "@/components/morf.vue";
import {
  exportExcel,
  openDownloadDialog,
  workbook2blob
} from "@/js/exportExcel.js";
export default {
  name:"shopmanage",
  components: {
    morf
  },
  data() {
    return {
      loadingInstance: null,
      search_info: {
        mch_id: "",
        mch_name: "",
        mch_type: "3",
        contact_man: "",
        service_charge: "",
        date: []
      },
      mch_type_options: [
        { label: "自然人", value: "0" },
        { label: "个体户", value: "1" },
        { label: "企业", value: "2" },
        { label: "全部", value: "3" }
      ],
      merfshow: false,
      search_in: "",
      service_id: localStorage.getItem("service_id"),
      select_type: "1",
      date: "",
      range: [],
      mch_list: [],
      mch_type: "",
      all_mch: [],
      range_list: [
        {
          label: "直属"
        },
        {
          label: "下级"
        }
      ],
      // 表头样式
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        }
      },
      rowStyleOption: {
        clickHighlight: true,
        stripe: true
      },
      // edit option 修改后的返回值
      editOption: {
        // cell value change
        cellValueChange: ({ row, column }) => {
          console.log("cellValueChange row::", row);
          console.log("cellValueChange column::", column);
        }
      },
      //刷新表格
      mcgTableShow: true,
      // 排序
      sortOption: {
        sortChange: params => {
          console.log("sortChange::", params);
          this.sortChange(params);
        }
      },
      columns: [
        // 标题第一列
        {
          field: "",
          key: "b",
          title: "序号",
          width: 50,
          align: "center",
          fixed: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span class="text-bold" style="color:#1890ff;font-weight:700">
                {rowIndex + 1}
              </span>
            );
          }
        },
        // 表头信息
        {
          field: "mch_id",
          key: "mch_id",
          title: "商户id",
          align: "left",
          width: 100,
          edit: false,
          fixed: "left"
        },
        {
          field: "mch_name",
          key: "mch_name",
          title: "商户名称",
          align: "left",
          width: 130,
          edit: true,
          fixed: "left",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "contact_man",
          key: "contact_man",
          title: "商户联系人",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "mch_type",
          key: "mch_type",
          title: "商户类型",
          align: "left",
          width: 100,
          edit: false
        },
        {
          field: "mobile_no",
          key: "mobile_no",
          title: "联系电话",
          align: "left",
          width: 100,
          edit: true
        },
        /* {
          field: "people_yew",
          key: "people_yew",
          title: "业务员",
          align: "left",
          width: 100,
          edit: true
        }, */
        {
          field: "service_charge",
          key: "service_charge",
          title: "服务费率",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "oper_date",
          key: "oper_date",
          title: "创建时间",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "operate",
          key: "operate",
          title: "操作",
          align: "left",
          width: 100,
          fixed: "right",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <button
                  style="background-color:#66B1FF; border:none;font-style:none; height:30px;color:#fff;border-radius:2px;"
                  on-click={() => this.saveChange(rowIndex)}
                >
                  修改
                </button>
                &nbsp;
              </span>
            );
          }
        }
      ]
    };
  },
  /* <button
                  style="background-color:#F78989; border:none;font-style:none; height:30px;color:#fff;border-radius:2px;"
                  on-click={() => this.removeS(rowIndex)}
                >
                  删除
                </button> */
  methods: {
    search() {
      this.loadingInstance.show();
      this.mch_list = [];
      var dateArr = [
        Date.parse(this.search_info.date[0]),
        Date.parse(this.search_info.date[1])
      ];
      /* for (var i = 0; i < this.all_mch.length; i++) {
        this.mch_list.push(this.all_mch[i]);
      } */
      var arrlist = [];
      var type = "";
      var keylist = [];
      switch (this.search_info.mch_type) {
        case "3":
          break;
        case "2":
          type = "企业";
          break;
        case "1":
          type = "个体户";
          break;
        case "0":
          type = "自然人";
          break;
      }
      for (var i = 0; i < this.all_mch.length; i++) {
        arrlist.push(this.all_mch[i]);
      }
      if (arrlist.length > 0) {
        for (var i = 0; i < arrlist.length; i++) {
          var date = Date.parse(arrlist[i].oper_date);
          if (date > dateArr[0] && date < dateArr[1]) {
            keylist.push(arrlist[i]);
          }
        }
        arrlist = keylist;
        keylist = [];
      }
      if (
        this.search_info.mch_type != "3" &&
        type != "" &&
        arrlist.length > 0
      ) {
        for (var i = 0; i < arrlist.length; i++) {
          if (arrlist[i].mch_type == type) {
            keylist.push(arrlist[i]);
          }
        }
        arrlist = keylist;
        keylist = [];
      }
      if (this.search_info.mch_id && arrlist.length > 0) {
        for (var i = 0; i < arrlist.length; i++) {
          if (arrlist[i].mch_id.indexOf(this.search_info.mch_id) >= 0) {
            keylist.push(arrlist[i]);
          }
        }
        arrlist = keylist;
        keylist = [];
      }
      if (this.search_info.mch_name && arrlist.length > 0) {
        for (var i = 0; i < arrlist.length; i++) {
          if (arrlist[i].mch_name.indexOf(this.search_info.mch_name) >= 0) {
            keylist.push(arrlist[i]);
          }
        }
        arrlist = keylist;
        keylist = [];
      }
      if (this.search_info.service_charge && arrlist.length > 0) {
        for (var i = 0; i < arrlist.length; i++) {
          if (
            String(arrlist[i].service_charge) == this.search_info.service_charge
          ) {
            keylist.push(arrlist[i]);
          }
        }
        arrlist = keylist;
        keylist = [];
      }
      if (this.search_info.contact_man && arrlist.length > 0) {
        for (var i = 0; i < arrlist.length; i++) {
          if (
            arrlist[i].contact_man.indexOf(this.search_info.contact_man) >= 0
          ) {
            keylist.push(arrlist[i]);
          }
        }
        arrlist = keylist;
        keylist = [];
      }
      this.loadingInstance.close();
      this.mch_list = arrlist;
    },
    resove() {
      this.search_info = {
        mch_id: "",
        mch_name: "",
        mch_type: "3",
        contact_man: "",
        service_charge: "",
        date: []
      };
      this.setTime();
    },
    test() {
      // openDownloadDialog('data',"测试")
    },
    // 表格导出
    exportExcel() {
      var data = [];
      for (var i = 0; i < this.all_mch.length; i++) {
        var dataitem = {};
        for (var key in this.all_mch[i]) {
          switch (key) {
            case "mch_id":
              dataitem["店铺id"] = this.all_mch[i][key];
              break;
            case "mch_name":
              dataitem["店铺名称"] = this.all_mch[i][key];
              break;
            case "contact_man":
              dataitem["联系人"] = this.all_mch[i][key];
              break;
            case "mch_type":
              dataitem["商户类型"] = this.all_mch[i][key];
              break;
            case "account_code":
              dataitem["银行卡号"] = this.all_mch[i][key];
              break;
            case "address":
              dataitem["地址"] = this.all_mch[i][key];
              break;
            case "legal_person_name":
              dataitem["法人姓名"] = this.all_mch[i][key];
              break;
            case "oper_date":
              dataitem["创建时间"] = this.all_mch[i][key];
              break;

            case "mch_type":
              dataitem["店铺类型"] = this.all_mch[i][key];
              break;
            case "mobile_no":
              dataitem["联系人手机号"] = this.all_mch[i][key];
              break;
            case "open_bank_name":
              dataitem["开户银行名称"] = this.all_mch[i][key];
              break;
            case "service_charge":
              dataitem["服务费率"] = this.all_mch[i][key];
              break;
          }
        }
        console.log(dataitem)
        data.push(dataitem);
      }
      exportExcel(data, "成员信息列表.xls");
      // console.log( JSON.stringify(data));
      /* var arr = '[{"商户类型":2,"店铺名称":"江苏峰厦网络科技有限公司","联系人":"张三","创建时间":"2022/8/2 8:44:34","店铺id":"4764174126"},{"商户类型":2,"店铺名称":"灌云县伊山镇科乐超市","联系人":"张三","创建时间":"2022/8/17 0:00:00","店铺id":"7376872402"},{"商户类型":3,"店铺名称":"保定正源电气科技有限公司","联系人":"张三","创建时间":"2022/8/15 0:00:00","店铺id":"6640772705"},{"商户类型":2,"店铺名称":"测试2","联系人":"张三","创建时间":"2022/8/10 0:00:00","店铺id":"1556062840"}]'
      exportExcel(JSON.parse(arr),"成员信息列表.xls") */
    },
    saveChange(index) {
      this.mch_id = this.mch_list[index].mch_id;
      console.log(this.mch_id)
      this.merfshow = true;
    },
    removeS(index) {
      console.log(index);
    },
    async getShop() {
      try {
        var { data: res } = await getMerchantlist(
          {
            access_token: localStorage.getItem("access_token")
          }
        );
      } catch (e) {
        this.$message.error("出错了", e);
      }
      if (res.resp_data) {
        for (var i = 0; i < res.resp_data.length; i++) {
          this.getInfo(res.resp_data[i].merchant_id);
        }
      }
      /* async function getInfo(mch_id,url) {

      } */
    },
    searchLike() {
      // if(this.select_type==)
      var key = "";
      switch (this.select_type) {
        case "1":
          key = "mch_name";
          break;
        case "2":
          key = "oper_date";
          break;
        case "3":
          key = "mch_id";
          break;
      }
      var arr = this.mch_list;
      this.mch_list = [];
      if (this.search_in == "") {
        this.mch_list = this.all_mch;
        return;
      }
      for (var x in arr) {
        if (String(arr[x][key]).indexOf(this.search_in) >= 0) {
          this.mch_list.push(arr[x]);
        }
      }
      if (this.mch_list.length == 0) {
        this.mch_list = this.all_mch;
        this.warnMessage("未找到相似信息");
      }
    },
    async getInfo(mch_id) {
      var data = {
        merchant_id: mch_id,
        access_token: localStorage.getItem("access_token")
      };
      try {
        var { data: res } = await queryMerchant(data);
      } catch (error) {
        console.log("出错了", error);
      }
      console.log(res);
      switch (res.resp_data.mch_type) {
        case 0:
          res.resp_data.mch_type = "自然人";
          break;
        case 1:
          res.resp_data.mch_type = "个体户";
          break;
        case 2:
          res.resp_data.mch_type = "企业";
          break;
      }
      res.resp_data.mch_id = mch_id;
      res.resp_data.rowKey = mch_id;

      this.all_mch.push(res.resp_data);
      // console.log(JSON.stringify(this.all_mch))
    },
    consoleResult() {
      console.log(this.date);
    },
    gTime(res) {
      /*console.log(res);
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      console.log(start,end)
       var start = this.formatDate(res[0]);
      var end = this.formatDate(res[1]);
      console.log(start, end); */
    },
    setTime() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.search_info.date = [start, end];
    }
  },
  mounted() {
    this.getShop();
    this.setTime();
    this.loadingInstance = this.$veLoading({
      target: document.querySelector("#loading-container"),
      // 等同于
      // target:"#loading-container"
      name: "wave"
    });
    // this.search_info.date=
  },
  destroyed() {
    this.loadingInstance.destroy();
  }
};
</script>
<style scoped>
.button-operate {
  width: 30px;
  background-color: rgb(88, 140, 213);
}
.fa {
  height: 100%;
  width: 100%;
  background-color: #fff;
  background-position: center center;
  background-attachment: fixed;
  background-size: 100% auto;
}
.form-box {
  width: 100%;
  height: 280px;
  /* background-color: rgba(255, 110, 110, 0.148); */
}
.form-father {
  padding-left: 100px;
  padding-right: 100px;
  display: flex;
  justify-content: space-between;
}
.el-form-item {
  width: 300px;
}
.el-form-item >>> label {
  padding: 0;
}
.btn-father {
  padding-right: 100px;
  display: flex;
  justify-content: space-between;
}
.tab-box {
  padding-left: 100px;
  padding-right: 100px;
}
.detail-father {
  width: auto;
  height: auto;
  position: absolute;
  /* top: 0px; */
  top: 50%;
  left: 50%;
  transform: translate(-50% -50%);
  background: #fff;
  z-index: 1000;
}
.close-morf {
  position: fixed;
  z-index: 1001;
  top: 80px;
  right: 250px;
  font-size: 60px;
  text-align: center;
  color: red;
  cursor: pointer;
}
</style>
